var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.538,
    height: 20.538,
    viewBox: "0 0 20.538 20.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#454f63;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.683,13.092A8.592,8.592,0,1,1,13.092,4.5a8.592,8.592,0,0,1,8.592,8.592Z",
    transform: "translate(-4.5 -4.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.647,29.647l-4.672-4.672",
    transform: "translate(-10.315 -10.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,16.5h6.444",
    transform: "translate(-6.63 -7.908)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherZoomOut);
export default __webpack_public_path__ + "static/media/feather-zoom-out.2d351062ae5852c46f3a49c3a6eaa433.svg";
export { ForwardRef as ReactComponent };